"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.sitemapper = exports.sitemapperResultSchema = exports.sitemapperArgsSchema = void 0;
var zod_1 = require("zod");
var common_1 = require("./common");
exports.sitemapperArgsSchema = zod_1.z.object({
    url: zod_1.z
        .string()
        .describe('The URL to start the crawl from (e.g., "example.com" or "https://example.com/page")'),
    crawlMode: zod_1.z
        .enum(['Sitemap', 'Internal Crawl', 'Both'])
        .default('Sitemap')
        .describe('Crawl mode: "Sitemap" uses sitemap.xml only, "Internal Crawl" crawls internal links up to specified depth, "Both" combines both methods'),
    crawlDepth: zod_1.z
        .number()
        .int()
        .min(1)
        .max(10)
        .default(4)
        .describe('How many levels of links to crawl from starting URL. Defaults to 4.'),
    maxUrlLimits: zod_1.z
        .number()
        .int()
        .min(-1)
        .default(50)
        .describe('Maximum number of URLs to return. Use -1 for unlimited. Default is 50.'),
    emitMode: common_1.emitModeSchema.default('single').describe('The mode to emit the data in.'),
});
exports.sitemapperResultSchema = zod_1.z.object({
    urls: zod_1.z.array(zod_1.z.string()).describe('Collection of discovered URLs'),
    totalFound: zod_1.z.number().describe('Total number of URLs found before applying maxUrlLimits'),
    method: zod_1.z.enum(['sitemap', 'internal_crawl', 'both']).describe('Method used to discover URLs'),
});
exports.sitemapper = (0, common_1.createEmitModeToolMetadata)({
    id: 'sitemapper',
    displayName: 'Sitemapper',
    displayDescription: 'Discover and collect URLs from a website using sitemaps and/or internal link crawling. Supports multiple crawl modes and depth control.',
    category: 'native',
    color: common_1.BRAND_COLORS.NATIVE,
    backgroundColor: (0, common_1.createBgColor)(common_1.BRAND_COLORS.NATIVE),
    icon: 'search',
    argsSchema: exports.sitemapperArgsSchema,
}, exports.sitemapperResultSchema);
